// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.cancel-sub-offer-page[data-v-0e2f1175] {\n\tcolor: #424982;\n}\n", ""]);
// Exports
module.exports = exports;
